import MinHeap from 'min-heap';

export class HistoryBuilder {
  constructor(historyData) {
    this.data = historyData;
    this.heap = this._buildHeap();
    this.revisions = [];
    this._buildRevisions();
  }

  _buildHeap() {
    const heap = new MinHeap((l, r) => {
      return l.timestamp - r.timestamp;
    });

    // first entry is the live entry, so we don't need it for the revisions
    this.data.metaHistory.shift();

    for (const revision of this.data.metaHistory) {
      revision.lastUpdatedTime = Math.trunc(revision.lastUpdatedTime);
      const heapEntry = { timestamp: revision.lastUpdatedTime, loc: 'meta' };
      heap.insert(heapEntry);
    }

    for (const arc in this.data.subWorkflowHistory) {
      // first entry is the live entry, so we don't need it for revisions
      this.data.subWorkflowHistory[arc].shift();
      for (const revision of this.data.subWorkflowHistory[arc]) {
        revision.lastUpdatedTime = Math.trunc(revision.lastUpdatedTime);
        const heapEntry = { timestamp: revision.lastUpdatedTime, loc: arc, createdBy: revision.createdBy };
        heap.insert(heapEntry);
      }
    }
    return heap;
  }

  _buildRevisions() {
    let currentHeapEntry = this.heap.removeHead();
    while (currentHeapEntry) {
      const metaElem = this.data.metaHistory[0];
      const entry = {
        workflowName: metaElem.workflowName,
        selectorAttributes: metaElem.selectorAttributes,
        subWorkflows: [],
        changed: [],
        lastUpdatedTime: currentHeapEntry.timestamp,
        createdBy: currentHeapEntry.createdBy,
      };
      if (currentHeapEntry.timestamp === metaElem.lastUpdatedTime) {
        if (this.data.metaHistory.length > 1) {
          this.data.metaHistory.shift();
        }
        entry.changed.push('Metadata');
      }

      for (const arc in this.data.subWorkflowHistory) {
        const wfElem = this.data.subWorkflowHistory[arc][0];
        entry.subWorkflows.push(wfElem);
        if (currentHeapEntry.timestamp === wfElem.lastUpdatedTime) {
          if (this.data.subWorkflowHistory[arc].length > 1) {
            this.data.subWorkflowHistory[arc].shift();
          }
          entry.changed.push(arc);
        }
      }
      this.revisions.unshift(entry);

      for (let i = entry.changed.length; i > 1; i--) {
        // if more than 1 sub or meta changed with the revision, need to account for it in the heap
        this.heap.removeHead();
      }

      currentHeapEntry = this.heap.removeHead();
    }
  }
}
